import { Activity } from "lucide-react";

export function RunDetailPlaceholder() {
  return (
    <div className="h-full w-full flex flex-col items-center justify-center p-8 text-center select-none space-y-4">
      <div className="w-12 h-12 rounded-2xl bg-white dark:bg-stone-900 border border-stone-200 dark:border-stone-800 flex items-center justify-center shadow-xs">
        <Activity className="w-6 h-6 text-stone-400 dark:text-stone-500" />
      </div>
      <div className="space-y-1 max-w-sm">
        <h3 className="text-base font-bold text-stone-900 dark:text-stone-100">
          Select an Execution Run
        </h3>
        <p className="text-xs text-stone-500 dark:text-stone-400 leading-relaxed">
          Choose a run trace from the list to inspect step waterfall, tool call invocations,
          event streams, and LLM telemetry.
        </p>
      </div>
    </div>
  );
}
